<div class="custom-toast"
     [ngClass]="'toast-' + toast.type"
     [@toastAnimation]="'visible'">
  <div class="toast-content">
    <div class="toast-icon">
      <i [class]="getIconClass()"></i>
    </div>
    <div class="toast-text">
      <div class="toast-title">{{ toast.title }}</div>
      <div class="toast-message">{{ toast.message }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="ni ni-fat-remove"></i>
    </button>
  </div>
</div>
